import { render } from "./DeclaracaoIR.vue?vue&type=template&id=366efba0"
import script from "./DeclaracaoIR.vue?vue&type=script&lang=js"
export * from "./DeclaracaoIR.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__